import * as React from 'react';
import {ImportVehiclesResult} from "../../../model/importVehicles/ImportVehiclesResult";

interface ComponentProps {
	result: ImportVehiclesResult;
}

const ImportResultsTile: React.SFC<ComponentProps> = ({result}) => {
	return (
		<div style={{
			padding: '20px',
			textAlign: 'center',
			backgroundColor: 'rgba(17, 35, 99, 0.05)',
			borderRadius: '8px',
			margin: '10px 0'
		}}>
			<p style={{margin: '8px 0'}}>Total vehicles processed: <strong>{result.totalCount}</strong></p>
			<p style={{margin: '8px 0'}}>Successfully imported: <strong>{result.successCount}</strong></p>
			<p style={{margin: '8px 0'}}>Already exists: <strong>{result.alreadyExistsCount}</strong></p>
			<p style={{margin: '8px 0'}}>Invalid registration: <strong>{result.invalidRegistrationCount}</strong></p>
		</div>
	);
};

export default ImportResultsTile;
